import React from 'react';
import { Box, Container, Grid, Paper, Typography, Divider, useMediaQuery } from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';
import AccountSidebar from '../components/Account/AccountSidebar';
import { useTheme } from '@mui/material/styles';

/**
 * Layout component for account-related pages
 * Provides a consistent layout with sidebar navigation
 */
function AccountLayout({ children }) {
  const { accountId } = useParams();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <Grid container spacing={3}>
        {/* Sidebar - Only shown as a fixed column on desktop */}
        {!isMobile && (
          <Grid item md={3} lg={2}>
            <Paper
              sx={{
                p: 2,
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
              }}
            >
              <AccountSidebar accountId={accountId} />
            </Paper>
          </Grid>
        )}
        
        {/* Main Content */}
        <Grid item xs={12} md={isMobile ? 12 : 9} lg={isMobile ? 12 : 10}>
          {/* Mobile Sidebar - Only shown on mobile */}
          {isMobile && (
            <Box sx={{ mb: 2 }}>
              <AccountSidebar accountId={accountId} />
            </Box>
          )}
          
          <Paper
            sx={{
              p: 2,
              display: 'flex',
              flexDirection: 'column',
              minHeight: '80vh',
            }}
          >
            {children}
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
}

export default AccountLayout; 